import React, { createContext, useContext, type ReactNode } from 'react';

import type { Config } from 'app/config';
import createAuthService from 'app/services/auth';
import createPasswordService from 'app/services/password';
import createCognitoService from 'app/services/cognito';
import createHyrox365Service from 'app/services/hyrox365';

const createServices = (config: Config) => ({
  auth: createAuthService({
    clientId: config.REACT_APP_AUTH_CLIENT_ID,
    clientSecret: config.REACT_APP_AUTH_CLIENT_SECRET,
    url: config.REACT_APP_AUTH_URL,
    oneFiitAuthUrl: config.REACT_APP_ONE_FIIT_AUTH_URL,
    oneFiitClientId: config.REACT_APP_CLIENT_ID_FOR_ONE_FIIT,
  }),
  password: createPasswordService({
    url: config.REACT_APP_PASSWORD_URL,
  }),
  cognito: createCognitoService({
    url: config.REACT_APP_COGNITO_EXCHANGE_URL,
    oneFiitAuthUrl: config.REACT_APP_ONE_FIIT_AUTH_URL,
    clientId: config.REACT_APP_CLIENT_ID_FOR_ONE_FIIT,
  }),
  hyrox365: createHyrox365Service({
    apiUrl: config.REACT_APP_HYROX_API_URL,
  }),
});

const context = createContext({} as ReturnType<typeof createServices>);
const { Provider } = context;

export const ServicesProvider = ({ children, config }: { children: ReactNode; config: Config }) => (
  <Provider value={createServices(config)}>{children}</Provider>
);

export default () => useContext(context);
